import { api } from '.'

export const sendGiftApi = api.injectEndpoints({
  endpoints: build => ({
    sendGift: build.query({
      query: ({ uuid, mobile_phone }) => ({
        url: `/mega_cards/${uuid}/send-gift/`,
        method: 'POST',
        body: { mobile_phone }
      })
    }),
    verifyGift: build.mutation({
      query: ({ uuid, mobile_phone, code, date_of_gift, message }) => ({
        url: `/mega_cards/${uuid}/verify-gift/`,
        method: 'POST',
        body: {
          mobile_phone,
          code,
          ...(date_of_gift ? { date_of_gift } : {}),
          ...(message ? { message } : {})
        }
      })
    }),
    cancelGift: build.mutation({
      query: ({ uuid }) => ({
        url: `/mega_cards/${uuid}/cancel-gift/`,
        method: 'POST'
      })
    }),
    verifyCancelGift: build.mutation({
      query: ({ uuid, code }) => ({
        url: `/mega_cards/${uuid}/verify-cancel-gift/`,
        method: 'POST',
        body: { code }
      })
    })
  })
})

export const {
  useLazySendGiftQuery,
  useVerifyGiftMutation,
  useCancelGiftMutation,
  useVerifyCancelGiftMutation
} = sendGiftApi
